import { CalendarMonthOutlined } from "@mui/icons-material";
import { Button, IconButton, Menu, Stack, Tooltip, Typography } from "@mui/material";
import { useRef, useState } from "react";

import useDisclosure from "../../../hooks/useDisclosure";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

const ConcernTicketFiltering = ({ setDateFrom, setDateTo }) => {
  const [tempDateFrom, setTempDateFrom] = useState(null);
  const [tempDateTo, setTempDateTo] = useState(null);

  const ref = useRef(null);

  const { open, onToggle } = useDisclosure();

  const onApplyAction = () => {
    setDateFrom(tempDateFrom ? moment(tempDateFrom).format("YYYY-MM-DD") : null);
    setDateTo(tempDateTo ? moment(tempDateTo).format("YYYY-MM-DD") : null);
    onToggle();
  };

  const onClearAction = () => {
    setTempDateFrom(null);
    setTempDateTo(null);
  };

  return (
    <>
      <Tooltip title={"Filter Date Created"} placement="bottom-start">
        <IconButton ref={ref} onClick={onToggle}>
          <CalendarMonthOutlined sx={{ fontSize: "28px" }} />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={ref.current}
        open={open}
        onClose={onToggle}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Stack sx={{ padding: 2, maxHeight: "300px", minWidth: "300px" }}>
          <Stack gap={2}>
            <Typography color="primary" sx={{ fontSize: "14px" }}>
              Filter Date Created:{" "}
            </Typography>

            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker label="Date From" value={tempDateFrom} onChange={(newValue) => setTempDateFrom(newValue)} />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker label="Date To" value={tempDateTo} minDate={tempDateFrom} onChange={(newValue) => setTempDateTo(newValue)} />
            </LocalizationProvider>
          </Stack>

          <Stack marginTop={1} direction="row" sx={{ justifyContent: "space-between" }}>
            <Button
              onClick={onApplyAction}
              disabled={(tempDateFrom && !tempDateTo) || (!tempDateFrom && tempDateTo)}
              sx={{
                ":disabled": {
                  backgroundColor: "transparent",
                  color: "#3f305f",
                  cursor: "not-allowed",
                },
              }}
            >
              Filter
            </Button>
            <Button onClick={onClearAction}>Clear</Button>
          </Stack>
        </Stack>
      </Menu>
    </>
  );
};

export default ConcernTicketFiltering;
